import { svg } from "lit";
const icon = svg `<path d="M11.25 4.5V16.6269L5.55382 10.9308L4.5 12L12 19.5L19.5 12L18.4461 10.9308L12.75 16.6269V4.5H11.25Z" fill="currentColor"/>`;
export default icon;
